import React from "react";

import { DeviceType, MedicalDevice as MedicalDeviceModel } from "@/models/MedicalDeviceModel.ts";
import { MedicalDevice } from "@/pages/patient-medical-file/MedicalDevice.tsx";
import { Queries } from "@/queries/Queries.ts";
import { toDateTime } from "@/utils/dateUtils.ts";

export const MedicalDeviceListContent: React.FC<{ patientId: string }> = ({ patientId }) => {
  const medicalDevices = Queries.diabetes.useMedicalDevices(patientId);

  return (
    <>
      {dedupeMD(medicalDevices).map(medicalDevice => (
        <MedicalDevice key={medicalDevice.id} device={medicalDevice} />
      ))}
    </>
  );
};

const findMDbyType = (type: DeviceType, list: MedicalDeviceModel[]) => list.find(elem => elem.kind === type);

const filterMDbyType = (type: DeviceType, list: MedicalDeviceModel[]) => list.filter(device => device.kind !== type);

const dedupeMD = (medicalDevices: MedicalDeviceModel[]) =>
  medicalDevices.reduce((devices, md) => {
    const occurence = findMDbyType(md.kind, devices);
    if (occurence) {
      if (toDateTime(md.lastUpload) > toDateTime(occurence.lastUpload)) {
        return [...filterMDbyType(occurence.kind, devices), md];
      }
      return devices;
    }
    return [...devices, md];
  }, [] as MedicalDeviceModel[]);
